import { cn } from "@/lib/utils";

export const SIMULATOR_METRICS_GRAY =
  "text-gray-500 dark:text-white";

export const SIMULATOR_METRICS_POSITIVE = "text-[#06E363]";
export const SIMULATOR_METRICS_NEGATIVE = "text-[#E00101]";

export const simulatorMetricsLabelClass =
  "font-[family-name:var(--font-primary)] text-sm font-normal text-gray-500 dark:text-white";

export const simulatorMetricsHeaderClass =
  "font-[family-name:var(--font-primary)] text-sm font-normal text-gray-500 dark:text-sidebar-muted-foreground";

export const simulatorMetricsValueClass =
  "font-[family-name:var(--font-primary)] text-sm font-medium text-gray-500 tabular-nums dark:text-white";

export const simulatorMetricsSummaryHeroClass =
  "font-[family-name:var(--font-primary)] text-lg font-semibold tabular-nums";

export function simulatorMetricsDeltaToneClass(delta: number | null): string {
  if (delta == null) return SIMULATOR_METRICS_GRAY;
  return delta >= 0 ? SIMULATOR_METRICS_POSITIVE : SIMULATOR_METRICS_NEGATIVE;
}

export function cnSimulatorMetricsDelta(delta: number | null, baseClass: string): string {
  return cn(baseClass, simulatorMetricsDeltaToneClass(delta));
}

export function simulatorMetricsDeltaProps(
  delta: number | null,
): { "data-simulator-metrics-delta": "" } | Record<string, never> {
  return delta == null ? {} : { "data-simulator-metrics-delta": "" };
}
